/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agents_Trust_Same_ReviewInputs */

const en_directory_agents_trust_same_review = /** @type {(inputs: Directory_Agents_Trust_Same_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent submissions go through the same human editorial review as everyone else's — no fast lane, no exceptions.`)
};

const zh_directory_agents_trust_same_review = /** @type {(inputs: Directory_Agents_Trust_Same_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent 提交与人类提交走完全相同的人工编辑审核——没有捷径，没有例外。`)
};

/**
* | output |
* | --- |
* | "Agent submissions go through the same human editorial review as everyone else's — no fast lane, no exceptions." |
*
* @param {Directory_Agents_Trust_Same_ReviewInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agents_trust_same_review = /** @type {((inputs?: Directory_Agents_Trust_Same_ReviewInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agents_Trust_Same_ReviewInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agents_trust_same_review(inputs)
	return zh_directory_agents_trust_same_review(inputs)
});
export { directory_agents_trust_same_review as "directory.agents.trust_same_review" }